/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GeoPoint
 */
export interface GeoPoint {
    /**
     * 
     * @type {number}
     * @memberof GeoPoint
     */
    lat?: number;
    /**
     * 
     * @type {number}
     * @memberof GeoPoint
     */
    lng?: number;
}

/**
 * Check if a given object implements the GeoPoint interface.
 */
export function instanceOfGeoPoint(value: object): value is GeoPoint {
    return true;
}

export function GeoPointFromJSON(json: any): GeoPoint {
    return GeoPointFromJSONTyped(json, false);
}

export function GeoPointFromJSONTyped(json: any, ignoreDiscriminator: boolean): GeoPoint {
    if (json == null) {
        return json;
    }
    return {
        
        'lat': json['lat'] == null ? undefined : json['lat'],
        'lng': json['lng'] == null ? undefined : json['lng'],
    };
}

export function GeoPointToJSON(json: any): GeoPoint {
    return GeoPointToJSONTyped(json, false);
}

export function GeoPointToJSONTyped(value?: GeoPoint | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'lat': value['lat'],
        'lng': value['lng'],
    };
}

